import React from 'react'
import { withRouter } from 'react-router-dom'
import axios from 'axios'
import { Form, Button, Icon, Table, Select, Checkbox, Alert } from 'antd'
import apiPath from 'apiPath'

import '../default.css'

//const confirm = Modal.confirm;

const formItemLayout = {
	labelCol: {
		xs: { span: 24 },
		sm: { span: 6 },
	},
	wrapperCol: {
		xs: { span: 24 },
		sm: { span: 14 },
	},
	marginBottom: '8pt',
}

class ViewPrograms extends React.Component {
	state = {
		fieldProgramResult: [],
		cruiseList: [],
		loading: false,
		selectedVoyageId: null,
	}
	init = () => {
		axios
			.get(apiPath + '/voyages',)
			.then((response) => {
				this.setState({ cruiseList: response.data })
				if (this.props.location.data) {
					if (this.props.location.data.searchCriteria) {
						this.props.form.setFieldsValue({
							Code: this.props.location.data.searchCriteria.Value,
						})
						this.fetchFieldPrograms(
							this.props.location.data.searchCriteria.Id
						)
					}
				}
			})
			.catch(console.error)
	}

	fetchFieldPrograms = (value) => {
		let code = this.state.cruiseList.filter((data) => data.id === value)[0]
			.code
		this.setState({ loading: true })
		this.setState({ selectedVoyageId: value })
		let path = apiPath + '/fieldAdmin/getFieldPrograms'
		axios
			.get(path, {
				withCredentials: true,
				params: { voyageId: value, voyage: code, cb: new Date().getTime() },
			})
			.then((response) => {
				this.setState({
					fieldProgramResult: response.data,
					loading: false,
				})
			})
			.catch(console.error)
	}
	componentDidMount() {
		this.init()
		if (this.props.location.data) {
			this.setState({
				showSaveSuccessful: this.props.location.data.successfullySaved,
			})

			setTimeout(() => {
				this.setState({ showSaveSuccessful: false })
			}, 6000)
		} else this.setState({ showSaveSuccessful: false })
	}
	editFieldProgram(fieldProgram) {
		fieldProgram.CruiseId = this.state.selectedVoyageId
		this.props.history.push({
			pathname: '/portal/fieldadmin/Edit Program',
			selectedFieldProgram: fieldProgram,
		})
	}
	render() {
		const { getFieldDecorator } = this.props.form
		const columns = [
			{
				title: 'Action',
				dataIndex: '',
				key: 'x',
				render: (text, record, index) => (
					<Button.Group size='large'>
						<Button
							className='editBtn'
							onClick={() => this.editFieldProgram(record)}
						>
							<Icon type='edit' />
							Edit
						</Button>
					</Button.Group>
				),
			},
			{
				title: 'Code',
				dataIndex: 'Code',
				key: 'Code',
				sorter: (a, b) => a.Code.localeCompare(b.Code),
			},
			{
				title: 'Title',
				dataIndex: 'Title',
				key: 'Title',
				sorter: (a, b) => a.Title.localeCompare(b.Title),
			},
			{ title: 'Voyage', dataIndex: 'CruiseNumber', key: 'CruiseNumber' },
			{
				title: 'Port',
				dataIndex: 'Port',
				key: 'Port',
				sorter: (a, b) => a.Port.localeCompare(b.Port),
			},
			{
				title: 'Has Main Image?',
				key: 'MainImage',
				render: (text, record, index) => (
					<Checkbox checked={record.MainImage != null}></Checkbox>
				),
			},
			{
				title: 'Number of carousel images',
				dataIndex: 'CarouselImages',
				key: 'CarouselImages',
				render: (text, record, index) => (
					<span>{Object.keys(record.CarouselImages).length}</span>
				),
			},
			{
				title: 'Preview',
				dataIndex: '',
				key: 'preview',
				render: (text, record, index) => {
					const previewurl =
						'/#/portal/fieldadmin/preview/' +
						record.CruiseId +
						'/' +
						record.Code
					return (
						<a href={previewurl} target='_blank'>
							preview
						</a>
					)
				},
			},
		]
		const options = this.state.cruiseList.map((d) => (
			<Select.Option key={d.id}>{d.code}</Select.Option>
		))

		return (
			<div
				style={{
					marginBottom: '25px',
					marginLeft: '15px',
					marginRight: '30px',
				}}
			>
				{this.state.showSaveSuccessful ? (
					<Alert
						type='success'
						message='Edit successful.'
						showIcon
						closable
					/>
				) : (
					<span></span>
				)}
				<legend>Criteria</legend>
				<Form onSubmit={this.handleSubmit}>
					<Form.Item label='Voyage' {...formItemLayout}>
						{getFieldDecorator('Code', {
							rules: [
								{
									required: true,
									message: 'Please choose a voyage.',
								},
							],
						})(
							<Select
								placeholder='Select One...'
								onChange={this.fetchFieldPrograms}
							>
								{options}
							</Select>
						)}
					</Form.Item>
				</Form>
				<legend>Field Programs</legend>
				<Table
					rowKey='ExcursionId'
					rowClassName={(record, index) =>
						index % 2 === 0 ? 'table-row-light' : 'table-row-dark'
					}
					columns={columns}
					loading={this.state.loading}
					pagination={false}
					dataSource={this.state.fieldProgramResult}
				/>
			</div>
		)
	}
}

export default withRouter(Form.create()(ViewPrograms))



// WEBPACK FOOTER //
// ./portal-components/Portal/FieldAdmin/ViewPrograms/index.jsx